import { Sha256 } from '@aws-crypto/sha256-browser';

const DIGEST_CHUNK_BYTES = 16 * 1024 * 1024;

const hex = (bytes: Uint8Array) =>
  [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');

export async function digestBlobSha256(file: Blob) {
  const digest = new Sha256();
  for (let offset = 0; offset < file.size; offset += DIGEST_CHUNK_BYTES) {
    const chunk = file.slice(offset, Math.min(file.size, offset + DIGEST_CHUNK_BYTES));
    digest.update(new Uint8Array(await chunk.arrayBuffer()));
  }
  return hex(await digest.digest());
}
